import { flow, getParent, types } from 'mobx-state-tree';
import ENUMS from '../../constants/enums';

const EbayOAuthConnection = types
  .model('ebayOAuthConnection', {
    destinationUrl: types.optional(types.string, ''),
    success: types.optional(types.boolean, true),
    loading: types.optional(types.boolean, false),
    firstAccountLoading: types.optional(types.boolean, true),
    // something like windowOpened to allow to show loading result
    marketplace: types.optional(types.number, 0),
    location: types.optional(types.string, ''),
    ebayWindowOpen: false,
  })
  .views(self => ({
    get settingsStore() {
      return getParent(self).settingsStore;
    },
    get transport5007() {
      return getParent(self).transport5007;
    },
  }))
  .volatile(() => ({
    authWindow: null,
  }))
  .actions(self => ({
    reinit() {
      self.destinationUrl = '';
      self.success = true;
      self.firstAccountLoading = true;
      self.loading = false;
      self.marketplace = 0;
      self.location = '';
    },
    getDestinationsAndSettings: flow(function* getDestinationsAndSettings() {
      yield self.settingsStore.connectionManagement.fetchConnectedAccounts();
      yield self.settingsStore.markets.initMarkets();
      yield self.settingsStore.listing.fetchListingOptions();
    }),
    toggleEbayWindowOpen: val => {
      self.ebayWindowOpen = val;
    },
    connectToEbay() {
      const {
        setSuccess,
        setLoading,
        setFirstAccountLoading,
        settingsStore,
        setDestinationUrl,
        getDestinationsAndSettings,
      } = self;

      if (!self.destinationUrl.includes('prompt=login')) {
        setDestinationUrl(`${self.destinationUrl}&prompt=login`);
      }

      self.toggleEbayWindowOpen(true);
      setLoading(true);
      self.authWindow = window.open(self.destinationUrl, '', 'height=750, width=750');
      const timer = setInterval(() => {
        if (!self.authWindow || self.authWindow.closed) {
          self.toggleEbayWindowOpen(false);
          clearInterval(timer);
        }
      }, 3000);
      window.addEventListener(
        'message',
        function handleWindowMessage(e) {
          if (!e.data.type || e.data.type !== 'OAuthAccessCode') {
            return;
          }
          self.authWindow.close();
          window.removeEventListener('message', handleWindowMessage, false);
          settingsStore.connectionManagement
            .sendCodeAfterConnection(e.data.payload, e.data.client)
            .then(() => settingsStore.browserHistory.replace('/'))
            .then(() => getDestinationsAndSettings())
            .then(() => {
              settingsStore.userProfile.updateOnboardingLevel('has store');
              setSuccess(true);
              setFirstAccountLoading(false);
              setLoading(false);
            })
            .catch(() => {
              setSuccess(false);
              setFirstAccountLoading(false);
              setLoading(false);
            });
        },
        false,
      );
    },
    setLocation(location) {
      if (location && typeof location === 'string') {
        self.location = location;
      }
    },
    setSuccess(success) {
      if (typeof success === 'boolean') {
        self.success = success;
      }
    },
    setLoading(loading) {
      if (typeof loading === 'boolean') {
        self.loading = loading;
      }
    },
    setFirstAccountLoading(loading) {
      if (typeof loading === 'boolean') {
        self.firstAccountLoading = loading;
      }
    },
    setMarketplace(marketplace) {
      if (marketplace && typeof marketplace === 'number') {
        self.marketplace = marketplace;
      }
    },
    setDestinationUrl(destinationUrl) {
      if (destinationUrl && typeof destinationUrl === 'string') {
        self.destinationUrl = destinationUrl;
      }
    },
    connectAccount() {
      const { marketplace, getDestination, setDestinationUrl } = self;
      getDestination(marketplace).then(data => {
        setDestinationUrl(data[0].authorizationUrl);
      });
    },
    getDestination: flow(function* getDestination(marketplace) {
      if (marketplace !== ENUMS.MARKETS.EBAY) {
        return null;
      }
      try {
        const params = {
          currency: 'USD',
          fields: 'authorizationUrl',
          type: 'EBAY',
        };
        const { data } = yield self.transport5007.fetch(
          'seller-account/v1/destination-marketplaces',
          params,
        );
        return data;
      } catch (error) {
        console.error('destination fetch fail: ', error);
        return null;
      }
    }),
  }));

export default EbayOAuthConnection;
